import * as jwtDecode from "jwt-decode";

import { AUTH_USER_TOKEN_KEY } from "./LocalStorage";

import { Storage } from "aws-amplify";

/** Custom Types */
import { UserRoleType } from "../CustomTypes";
import { USER_ROLES } from "./Consts";
import { Suburb, UserRole, Province, Industry } from "src/API";

export const validateToken = (token: any): boolean => {
  if (!token) {
    return false;
  }
  try {
    const decodedJwt: any = jwtDecode(token);
    return decodedJwt.exp >= Date.now() / 1000;
  } catch (e) {
    return false;
  }
};

/** Return user id from JWT */
export const getUserId = (): string => {
  const token = window.localStorage.getItem(AUTH_USER_TOKEN_KEY);
  if (token) {
    const decodedJwt: any = jwtDecode(token);
    return decodedJwt.sub;
  }
  return "";
};

/** Return user id from JWT */
export const getUserRole = (): string => {
  const token = window.localStorage.getItem(AUTH_USER_TOKEN_KEY);
  if (token) {
    const decodedJwt: any = jwtDecode(token);
    return decodedJwt["cognito:groups"][0];
  }
  return "";
};

/** Convert text to a selector */
export const convertToSelector = (text: string): string => {
  return text.toLowerCase().replace(" ", "-");
};

/** Get array from object */
export const getArrayFromObject = (objectToConvert: any) => {
  const arrayFromObject = [];

  for (const item in objectToConvert) {
    if (Object.keys(objectToConvert[item]).length > 0) {
      arrayFromObject.push({
        ...objectToConvert[item]
      });
    }
  }

  return arrayFromObject;
};

/**
 * Filter regardless of letter casing. Used by react table filter
 */
export const filterCaseInsensitive = (filter: any, row: any) => {
  const id = filter.pivotId || filter.id;
  return row[id] !== undefined
    ? String(row[id].toLowerCase()).startsWith(filter.value.toLowerCase())
    : true;
};

/** Display avatar image */
export const returnUserAvatar = async (
  avatarKey: string
): Promise<object | string> => {
  const result = await Storage.get(avatarKey).catch(err => {
    return "";
  });
  return result;
};

/** Return user roles */
export const returnUserRole = (role: UserRoleType): string => {
  switch (role) {
    case USER_ROLES.rootsSuperAdmin:
      return "Roots Super Admin";
    case USER_ROLES.rootsAdmin:
      return "Roots Admin";
    case USER_ROLES.consumerAdmin:
      return "Consumer Admin";
    case USER_ROLES.superUser:
      return "Super User";
    case USER_ROLES.user:
      return "User";
    default:
      return "Non-User";
  }
};

export const formatString = (
  toFix: string | UserRole | Province | Industry | null,
  allFirstCaps: boolean = false
) => {
  try {
    let toFixTemp = "";
    if (toFix) {
      toFixTemp = toFix;
    }
    if (allFirstCaps) {
      let sentence: string = "";
      const temp: string[] = toFixTemp
        .toLowerCase()
        .replace(/_/g, " ")
        .split(" ");
      temp.forEach(
        word =>
          (sentence +=
            word.charAt(0).toUpperCase() + word.substr(1).toLowerCase() + " ")
      );

      return sentence;
    }
    return (
      toFixTemp.charAt(0).toUpperCase() +
      toFixTemp
        .substr(1)
        .toLowerCase()
        .replace(/_/g, " ")
    );
  } catch (error) {
    return toFix;
  }
};

export const formatDropdown = (
  enumName: string | Suburb | UserRole | Province | null | undefined | any
) => {
  try {
    if (!enumName) {
      return { value: "", label: "" };
    }
    return { value: enumName, label: formatString(enumName || "") };
  } catch (error) {
    return { value: "", label: "" };
  }
};

export const formatTitle = (toFix: string = "") => {
  try {
    let sentence: string = "";
    const temp: string[] = toFix
      .toLowerCase()
      .replace(/-/g, " ")
      .replace(/\//g, "")
      .split(" ");
    temp.forEach(
      word =>
        (sentence +=
          word.charAt(0).toUpperCase() + word.substr(1).toLowerCase() + " ")
    );

    return formatString(sentence, true);
  } catch (error) {
    return "";
  }
};

/**
 * This function removes any undefined items from an array.
 * @param toClean
 */
export const cleanArray = (toClean: any[]) => {
  return toClean.filter(el => {
    return el != null;
  });
};



// WEBPACK FOOTER //
// ./src/Utils/Helpers.ts